<template>
    <div class="page bgcolorCream orderHistoryPage">
        <TopNavBar/>
        <div class="container my-4" v-if="orders">
            <div class="row mb-5">
                <div class="col-12">
                    <h1 class="text-center">Order History</h1>
                </div>
            </div>
            <div
                class="row mb-4 pb-4 border-bottom"
                v-for="order in orders"
            >
                <div class="col-md-7">
                    <h2>Order # {{ order.check_number || order.id }}</h2>
                    <h5 class="text-uppercase colorCrimson mb-3">Order placed: {{moment(order.added)}}</h5>
                    <div
                        class="items"
                        v-for="item in order.items"
                    >
                        <div class="mb-2 h4">X{{item.count}} {{item.title}}</div>
                        <div class="option regText" v-for="option in item.options"> +{{option.option_title}}</div>
                    </div>
                </div>
                <div class="col-md-5">
                </div>
                <div class="col-12 my-3"></div>
                <div class="col-6">
                    <div>Subtotal:</div>
                    <div>Total:</div>
                </div>
                <div class="col-6 text-right">
                    <div>${{order.subTotal}}</div>
                    <div>${{order.order_amount}}</div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import TopNavBar from "../../components/shared/TopNavBar";

    export default {
        name: "OrderHistory",
        components: {TopNavBar},
        data() {
            return {
                orders: null
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Orders"})
            this.$store.dispatch("user/getUserOrders", {
                callback: orders => {
                    this.orders = orders
                }
            });
        },
        methods: {
            moment(date) {
                date = date.split("T")[0]
                return moment(date, "YYYY-MM-DD").format("M/D/YY");
            }
        }
    }
</script>
